// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"4983ec9f","179":"9ffd1778","213":"0c8f1caa","219":"a11411ed","367":"03b327fc","445":"dd0e568e","453":"d1fa110c","547":"726d67dd","624":"712db40a","676":"854eb249","732":"74d40df9","824":"6c721a7a","955":"9fc1950d"}[chunkId] + ".chunk.js";
};